import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, input, OnChanges, signal, SimpleChanges, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { WidgetSupportTicketVm } from 'app/shared/generated/Administration/Models/Users/WidgetSupportTicketVm';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';

@Component({
    selector: 'pcg-support-ticket-widget',
    templateUrl: './support-ticket-widget.component.html',
    styleUrls: ['../resizable-notifications-widget/resizable-notifications-widget.component.scss', 
        '../resizable-widget/resizable-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ResizableWidgetComponent
    ]
})
export class SupportTicketWidgetComponent {

    private readonly http = inject(HttpClient);
    private readonly router = inject(Router);
    private readonly ms = inject(SystemMessageService);
    private readonly cdr = inject(ChangeDetectorRef);

    readonly isLoading = signal(true);
    readonly supportTickets = signal<WidgetSupportTicketVm[]>([]);

    ngOnInit() { this.initialize(); }

    createNewTicket(): void {
        this.http.get<SystemMessage>('api/HelpDesk/HelpDeskTicket/CreateTicket').subscribe({
            next: (msg) => {
                if (msg.isSuccessful) { this.router.navigateByUrl(`/support/tickets/edit/${msg.value}`); }
                else { this.ms.setSystemMessage(msg.message!, 'error'); }
            },
            error: (error) => {
                console.error('Error creating ticket:', error);
                this.ms.setSystemMessage('Error creating support ticket', 'error');
            },
        });
    }

    redirectToTicket(supportTicket: WidgetSupportTicketVm): void {
        this.router.navigateByUrl(`support/tickets/edit/${supportTicket.supportTicketId}`);
    }

    private initialize(): void {
        this.http.get<SystemMessage>('api/Admin/Widgets/GetSupportTicketWidgetData').subscribe({
            next: (msg) => {
                this.supportTickets.set(msg.model);
                this.isLoading.set(false);
                this.cdr.markForCheck();
            },
            error: (error) => {
                console.error('Error fetching support tickets:', error);
                this.isLoading.set(false);
                this.cdr.markForCheck();
            },
        });
    }
}
